import { Component, OnInit, ElementRef, ViewChild, OnDestroy, Inject, forwardRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BaseServiceService } from "src/app/services/base-service.service";
import { Utilities } from "src/app/helpers/utilities";
import { StaticData } from "src/app/helpers/static-data";

declare const supersetEmbeddedSdk: any;
@Component({
  selector: "app-superset-report",
  templateUrl: "./superset-report.component.html",
  styleUrls: ["./superset-report.component.css"]
})
export class SupersetReportComponent implements OnInit, OnDestroy {
  @ViewChild("dashboardContainer", { static: true }) dashboardContainer!: ElementRef;

  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  
  private currentEmbed: any = null; 
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(forwardRef(() => BaseServiceService)) public baseService: BaseServiceService,
    @Inject(forwardRef(() => Utilities)) public utility: Utilities
  ) {}
  
  private validarSesionInicial(): boolean {
    if (!StaticData.Usuario || !StaticData.Usuario.Token) {
      StaticData["MessajeNoAutenticado"] = true;
      this.router.navigate(["Home"]);
      return false;
    }

    return true;
  }

  ngOnInit(): void {
    if (!this.validarSesionInicial()) {
      return;
    }

    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const reportKey = params["reportKey"];
        if (reportKey) {
          this.loadReport(reportKey);
        }
      });
  }

  private async loadReport(reportKey: string): Promise<void> {
    if (!this.validarSesionInicial()) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;

    if (this.currentEmbed) {
      this.dashboardContainer.nativeElement.innerHTML = "";
      this.currentEmbed = null;
    }

    let obj = this.utility.GetApiModel("GetGuestToken", "SupersetController");
    let info = {
      componentName: 'SupersetReportComponent',
      controlName: 'GetGuestToken',
      processMessage: 'Cargando visualización del dashboard...',
    };

    this.baseService.Get(obj, null, info, `superset/guest-token/${reportKey}`, false, false)
      .then((response) => {
        const resData = response.Data ? response.Data : response;
        const tokenVal = resData.GuestToken || resData.token;
        const dashboardIdVal = resData.DashboardId || resData.dashboardId;
        const domainVal = resData.SupersetUrl || resData.supersetDomain;

        if (!resData || !tokenVal || !dashboardIdVal || !domainVal) {
          this.handleError("La API de reportes devolvió parámetros insuficientes.");
          return;
        }

        if (!supersetEmbeddedSdk || !supersetEmbeddedSdk.embedDashboard) {
  this.handleError("No se cargó el SDK embebido de Superset.");
  return;
}

    supersetEmbeddedSdk.embedDashboard({
      id: dashboardIdVal,
      supersetDomain: domainVal.replace(/\/$/, ""),
      mountPoint: this.dashboardContainer.nativeElement,
      fetchGuestToken: () => Promise.resolve(tokenVal),
      dashboardUiConfig: {
        hideTitle: false,
        hideChartControls: false,
        filters: {
          expanded: false
        }
      }
    }).then((result: any) => {
        this.currentEmbed = result;
        this.isLoading = false;
        }).catch((err: any) => {
          this.handleError("Error al inicializar el contenedor gráfico del reporte.");
        });
      })
      .catch((err) => {
        this.handleError("No se pudieron validar los permisos para visualizar este reporte.");
      });
  }

  private handleError(message: string): void {
    this.errorMessage = message;
    this.isLoading = false;
  }

  ngOnDestroy(): void {

    this.destroy$.next();
    this.destroy$.complete();

    if (
      this.dashboardContainer &&
      this.dashboardContainer.nativeElement
    ) {
      this.dashboardContainer.nativeElement.innerHTML = "";
    }
  }
}